module.exports = __webpack_public_path__ + "img/logo_black.4f7f996c.png";